import { Action } from 'redux';
import { combineEpics, Epic, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { changeLocation } from '../../actions/common';
import { RoutesPath } from '../../routes/index';
import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';
import {
    GO_TO_VIDEO_CREATOR_CREATE_PAGE,
    GoToVideoCreatorCreatePageAction
} from '../VideoCreatorTemplatesListPage/actions';

import { GO_TO_VIDEO_CREATOR_EDIT_PAGE, GoToVideoCreatorEditPageAction } from './actions';

const goToVideoCreatorCreateListEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
): Observable<Action> => {
    return action$.pipe(
        ofType(GO_TO_VIDEO_CREATOR_CREATE_PAGE),
        switchMap(
            (action: GoToVideoCreatorCreatePageAction): Observable<Action> => {
                const { templateId } = action;
                const {
                    commonData: { login }
                } = store$.value;

                return of(changeLocation(RoutesPath.videoCreatorEdit, { templateId, ulogin: login }, false));
            }
        )
    );
};

const goToVideoCreatorEditListEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
): Observable<Action> => {
    return action$.pipe(
        ofType(GO_TO_VIDEO_CREATOR_EDIT_PAGE),
        switchMap(
            (action: GoToVideoCreatorEditPageAction): Observable<Action> => {
                const { templateId, videoId } = action;
                const {
                    commonData: { login }
                } = store$.value;

                return of(
                    changeLocation(RoutesPath.videoCreatorEdit, { templateId, id: videoId, ulogin: login }, false)
                );
            }
        )
    );
};

export const videoCreatorMyVideoPageEpics = combineEpics(goToVideoCreatorCreateListEpic, goToVideoCreatorEditListEpic);
